import { QueryKeys } from '../../utils/queryKeys';

export const preCourseAssessmentKeys = {
    all: [QueryKeys.GET_PRE_ASSESSMENT_QUESTION],
    getPreCourseAssessmentKeys: (payload) => {
        const { courseId, languageid } = payload;

        return [...preCourseAssessmentKeys.all , courseId, languageid]
    }
};